<template>
    <div class="message-list">
        <div
            v-for="chat in chats"
            :key="chat.id"
            :class="['chat-item', { unread: chat.unreadCount > 0, active: activeChatId === chat.userId }]"
            @click="openChat(chat)"
        >
            <img  :src="chat.userImageUrl" alt="" class="chat-avatar">
            <div class="chat-info">
                <div class="chat-header">
                    <div class="chat-name">{{ chat.userName }}</div>
                    <div class="chat-time">{{ getRelativeTime(chat.lastSendTime) }}</div>
                </div>
                <div class="chat-preview">{{ chat.newContent }}</div>
            </div>
            <div v-if="chat.unReadNumber > 0" class="chat-unread">{{ chat.unReadNumber }}</div>
        </div>

        <div v-if="chats.length === 0" class="empty-state">
            <i class="fas fa-comments"></i>
            <h3>暂无聊天</h3>
            <p>您还没有与任何用户的聊天记录</p>
        </div>
        <Pagination v-if="chats.length > 0" :currentPage="page" :pageSizes="[10,20,30,40]"
                    :parentPageSize="size" :totalNumber="totalNumber"
                    @loadTable="loadTable"></Pagination>
    </div>
</template>

<script>
import Api from '@/components/Api/index.js'
import Pagination from "@/components/Pagination.vue";
import {getRelativeTime} from "../../util/util";

export default {
    name: 'ChatList',
    components: {Pagination},
    props: {
        // chats: {
        //     type: Array,
        //     default: () => []
        // }
    },
    data() {
        return {
            activeChatId: null,
            chats: [],
            page: 1,
            size: 10,
            totalNumber: 0
        }
    },
    methods: {
        getRelativeTime,
        openChat(chat) {
            chat.unReadNumber = 0
            this.activeChatId = chat.userId
            this.$emit('open-chat', chat)
        },
        loadTable(page) {
            this.page = page
            this.getMessageList()
        },
        //获取系统消息列表
        getMessageList() {
            new Api().userSendMessageList({page: this.page, size: this.size, q: {}}).then(res => {
                if (res.status === 200) {
                    this.chats = res.data.records
                    console.log(this.chats, 'skddkkdkdkd')
                    this.totalNumber = res.data.total
                    this.$emit('refreshNumber')
                }
            })
        },
    },
    mounted() {
        this.getMessageList()
    }
}
</script>

<style scoped>
.message-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
}

.chat-item {
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
    border: 1px solid #f1f1f1;
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;
}

.chat-item:hover {
    background-color: #f8f9fa;
    border-color: #e0e0e0;
}

.chat-item.active {
    background-color: #e8f4fc;
    border-color: #3498db;
}

.chat-item.unread {
    border-left: 4px solid #3498db;
}

.chat-avatar {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #3498db;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: 600;
    flex-shrink: 0;
}

.chat-info {
    flex: 1;
    min-width: 0;
}

.chat-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
}

.chat-name {
    font-weight: 600;
    color: #2c3e50;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat-time {
    color: #7f8c8d;
    font-size: 12px;
    flex-shrink: 0;
}

.chat-preview {
    color: #555;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.chat-unread {
    background-color: #e74c3c;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    flex-shrink: 0;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px;
    color: #7f8c8d;
    text-align: center;
}

.empty-state i {
    font-size: 60px;
    margin-bottom: 20px;
    color: #bdc3c7;
}

.empty-state h3 {
    margin-bottom: 10px;
    color: #2c3e50;
}
</style>